import Vue from 'vue';
import { openModal } from 'mycorems-app-shared';
import { recognition } from 'mycorems-app-accounts';
import settings from '@/account-settings/account-settings-repository';
import accountRepository from '../../account-repository';
import SetupAgencyModal from './SetupAgencyModal.vue';
import AddClientsModal from '../../client/AddClientsModal.vue';
import GetStartedModal from './GetStartedModal.vue';

export default Vue.extend({
  methods: {
    async setupStepOne(agencyId: string): Promise<string> {
      const apiKey = await settings.getApiKey(agencyId);
      return new Promise((resolve) => {
        if (!apiKey) {
          openModal(SetupAgencyModal, {
            parent: this,
            agencyId,
            title: 'Welcome to CM Reports!',
          }).onOk(() => {
            resolve(agencyId);
          });
        } else {
          resolve(agencyId);
        }
      });
    },
    setupStepTwo(agencyId: string) {
      accountRepository.count({ parentId: agencyId }).then((numClients) => {
        if (numClients === 0) {
          openModal(AddClientsModal, { parent: this, agencyId }).onDismiss(() => {
            openModal(GetStartedModal, { parent: this, agencyId });
          });
        }
      });
    },
  },
  created() {
    if (!recognition.isAgency()) return;
    const agencyId = recognition.getAccountId();
    if (!agencyId) return;
    this.setupStepOne(agencyId).then(this.setupStepTwo);
  },
});
